export const CookieKeys = {
  AutomationTest: 'sd_automation_test',
  InstanceUid: 'instance-uid',
  AuthUserId: 'auth_user_id',
  MyShopName: 'myShopCookieName',
  CitySlug: 'city_slug',
  YandexAbTestParam: '_ymab_param',
  RetailRocketUid: 'rcuid',
  AdmitAd: '_aid',
  Infoblock: 'sd_visited_infoblock',
  SmartCaptchaDebugOn: 'sd_smart_captcha_debug_on',
  YandexMetrikaUid: '_ym_uid',
  YandexMetrikaInitDate: '_ym_d',
  YandexMetrikaLoggedUid: '_sd_ym_logged_uid',
  YandexMetrikaLoggedUidV2: '_sd_ym_logged_uid_v2',
  ATTDisableAnalytics: '_sd_att_disable_analytics',
  ChekoutV2Enabled: '_sd_chekout_v2_enabled',
} as const;

export type CookieKeys = (typeof CookieKeys)[keyof typeof CookieKeys];
